import { useEffect, useRef } from "react";
import DailyIframe from "@daily-co/daily-js";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const DailyFrame = ({ roomUrl, token, onLeft }) => {
  const mount = useRef(null);
  const leftRef = useRef(onLeft);
  leftRef.current = onLeft;
  useEffect(() => {
    let cancelled = false;
    let frame = null;
    (async () => {
      const existing = DailyIframe.getCallInstance();
      if (existing) await existing.destroy();
      if (cancelled || !mount.current) return;
      frame = DailyIframe.createFrame(mount.current, {
        showLeaveButton: true,
        iframeStyle: { width: "100%", height: "70vh", border: "0", borderRadius: "8px" },
      });
      frame.on("left-meeting", () => leftRef.current());
      frame.join({ url: roomUrl, token }).catch(() => {});
    })();
    return () => { cancelled = true; if (frame) frame.destroy(); };
  }, [roomUrl, token]);
  return <div ref={mount} className="min-h-[70vh] w-full" data-testid="daily-frame" />;
};

export const VideoDialog = ({ session, title, onClose }) => (
  <Dialog open={!!session} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-5xl border-white/10 bg-[#0B0F17]" data-testid="video-dialog">
      <DialogHeader>
        <DialogTitle className="font-display">{title}</DialogTitle>
        <DialogDescription className="sr-only">Daily video</DialogDescription>
      </DialogHeader>
      {session && <DailyFrame roomUrl={session.room_url} token={session.token} onLeft={onClose} />}
    </DialogContent>
  </Dialog>
);
